import api from "../lib/api.ts";


export const loginUser = async (credentials: any) => {
    try {
        const response = await api.post("/auth/login", credentials);
        return response.data;
    } catch (error: any) {
        throw error.response?.data || error;
    }
};

export const registerBuyer = async (formData: FormData) => {
    try {
        const response = await api.post("/auth/registerbuyer", formData, {
            headers: { "Content-Type": "multipart/form-data" }, timeout: 30000
        });
        return response;
    } catch (error) {
        console.error("Buyer registration failed:", error);
        throw error;
    }
};

export const registerSeller = async (formData: FormData) => {
    try {
        const response = await api.post("/auth/registerseller", formData, {
            headers: { "Content-Type": "multipart/form-data" }, timeout: 30000
        });
        return response;
    } catch (error) {
        console.error("Seller registration failed:", error);
        throw error;
    }
};

export const forgotPassword = async (email: string) => {
    try {
        const response = await api.post("/auth/forgot-password", { email });
        return response.data;
    } catch (error: any) {
        throw error.response?.data || error;
    }
};

export const verifyEmail = async (
    token: string,
    uid?: string,
    slug?: string,
) => {
    try {
        let url = `/auth/verify-email?token=${token}`;
        if (uid) url += `&uid=${uid}`;
        if (slug) url += `&slug=${encodeURIComponent(slug)}`;
        const response = await api.get(url);
        return response.data;
    }catch (error: any) {
   throw error.response?.data || { error: error.message || "Unknown error" };
  }
};
